import {getEmphasizedFontWeight} from './get-emphasized-font-weight';

export const FONT_FAMILY = 'Matter, "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif';

export const BODY_TYPOGRAPHY = {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0em',
    fontFeatureSettings: "'kern' 1, 'liga' 1",
};

export const MICRO_TYPOGRAPHY = {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '120%',
    letterSpacing: '-0.12px',
    fontFeatureSettings: "'kern' 1, 'liga' 1, 'ss01' on",
};

/**
 * The text of a form field's label, shared by the MF `FormLabel` and MUI's `FormLabel`/`InputLabel` theme
 * override so both kinds of label look the same.
 */
export const formLabelTextStyles = {
    fontFamily: FONT_FAMILY,
    fontWeight: getEmphasizedFontWeight('body'),
    fontSize: BODY_TYPOGRAPHY.fontSize,
    lineHeight: BODY_TYPOGRAPHY.lineHeight,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
} as const;

/**
 * The text under a form field, shared by the MF `FormHelperText`/`FormErrorText` and MUI's
 * `FormHelperText` theme override.
 */
export const formHelperTextStyles = {
    ...MICRO_TYPOGRAPHY,
    margin: 0,
} as const;
